export default "__VITE_ASSET__6e391530__"